export const environmentVersion = {
  version: '1.0.0',
  commitHash: 'test',
  buildDate: '2025-07-03T23:05:49.968Z'
};